"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeSessionItem = exports.setSessionItem = exports.getSessionItem = void 0;

var getSessionItem = function getSessionItem(key) {
  return JSON.parse(sessionStorage.getItem(key));
};

exports.getSessionItem = getSessionItem;

var setSessionItem = function setSessionItem(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value));
};

exports.setSessionItem = setSessionItem;

var removeSessionItem = function removeSessionItem(key) {
  sessionStorage.removeItem(key);
};

exports.removeSessionItem = removeSessionItem;